import React from 'react';
import ConfirmationModal from '../modals/ConfirmationModal ';

const QuestionPrompt = ({
  question,
  setAnswer,
  handleSubmit,
  showModal,
  setShowModal,
  handleConfirm,
  styles
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.centered}>
        <h3>{question}</h3>
        <div style={styles.radioGroup}>
          <label style={styles.radioButton}>
            <input
              type="radio"
              name="answer"
              value="yes"
              onChange={(e) => setAnswer(e.target.value)}
            />
            Yes
          </label>
          <label style={styles.radioButton}>
            <input
              type="radio"
              name="answer"
              value="no"
              onChange={(e) => setAnswer(e.target.value)}
            />
            No
          </label>
        </div>
        <button style={styles.button} onClick={handleSubmit}>
          Submit
        </button>
      </div>
      {showModal && (
        <ConfirmationModal
          open={showModal}
          onClose={() => setShowModal(false)}
          onConfirm={handleConfirm}
          message="Are you sure? You will be redirected to the statement recording screen."
        />
      )}
    </div>
  );
};

export default QuestionPrompt;
